import { api } from "@/api";
import { RECAPTCHA_HEADER_NAME } from "@/constants";
import type {
  IAdministratorTokenRequest,
  IAppleLoginRequest,
  IFacebookLoginRequest,
  IResetPasswordRequest,
  ITokenRequest,
} from "./types";

export const getToken = async (
  requestData: ITokenRequest,
  reCaptchaToken?: string,
) =>
  (
    await api.post<string>("/authentication", requestData, {
      params: { e: requestData.e },
      headers: { [RECAPTCHA_HEADER_NAME]: reCaptchaToken },
    })
  ).data;

export const resetPassword = async (
  requestData: IResetPasswordRequest,
  reCaptchaToken?: string,
) =>
  await api.post("/authentication/reset-password", requestData, {
    headers: { [RECAPTCHA_HEADER_NAME]: reCaptchaToken },
  });

export const loginWithFacebookToken = async (
  requestData: IFacebookLoginRequest,
) =>
  (
    await api.post<string>("/authentication/facebook", requestData, {
      params: { e: requestData.e },
    })
  ).data;

export const loginWithAppleToken = async (requestData: IAppleLoginRequest) =>
  (
    await api.post<string>("/authentication/apple", requestData, {
      params: { e: requestData.e },
    })
  ).data;

export const destroyToken = async (token: string) =>
  api
    .post<string>(
      "/authentication/logout",
      {},
      { headers: { Authorization: `${token}` } },
    )
    .then((r) => r.data);

export const getAdministratorToken = async (data: IAdministratorTokenRequest) =>
  (await api.post<string>("/authentication/administrator", data)).data;
